import { z } from "zod";

export const brandingLogoSchema = z.object({
  file_url: z.url(),
  id: z.number().nullable(),
  original_name: z.string(),
});

export type BrandingLogo = z.infer<typeof brandingLogoSchema>;

export const brandingSchema = z.object({
  button_colour: z.string(),
  button_text_colour: z.string(),
  colour: z.string(),
  currency: z.string(),
  description_font_colour: z.string(),
  heading_font_colour: z.string(),
  icon_colour: z.string(),
  is_default: z.boolean(),
  label_font_colour: z.string(),
  locale: z.string(),
  logo: brandingLogoSchema.nullable(),
  name: z.string(),
  progress_bar_colour: z.string(),
  content_title_color: z.string(),
  font_url: z.url().nullable().optional(),
});

export type Branding = z.infer<typeof brandingSchema>;

export type BrandingColours = Omit<
  Branding,
  "logo" | "is_default" | "name" | "currency" | "locale" | "font_url"
>;
